import {
	LOGIN, 
	LOGIN_SUCCESS, 
	LOGIN_FAIL,
	LOGOUT, 
	LOGOUT_SUCCESS, 
	LOGOUT_FAIL,
} from "./Constants"

const initialState = {
	userIsLoggedIn: false,
	sessionIsLoading: false,
	error: null,
	sessionData: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case LOGIN:
			return {
				...state,
					sessionIsLoading: true
			}
		case LOGIN_SUCCESS:
			return {
				...state,
				userIsLoggedIn: true,
				sessionIsLoading: false,
				sessionData: action.payload
			}
		case LOGIN_FAIL:
			return {
				...state,
				sessionIsLoading: false,
				error: action.payload
			}
		case LOGOUT:
			return {
				...state,
				sessionIsLoading: true
			}
		case LOGOUT_SUCCESS:
			return {
				...state,
				userIsLoggedIn: false,
				sessionIsLoading: false,
				sessionData: []
			}
		case LOGOUT_FAIL:
			return {
				...state,
				sessionIsLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}